import "../assets/index-c221fe05.css";
import { n as s } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
import { N as a } from "../chunks/index-efb07851.mjs";
import n from "./NcPopover.mjs";
import i from "vue";
const o = {
  name: "NcUserBubbleDiv"
};
var l = function() {
  var e = this, r = e._self._c;
  return r("div", [e._t("trigger")], 2);
}, u = [], p = /* @__PURE__ */ s(
  o,
  l,
  u,
  !1,
  null,
  null,
  null,
  null
);
const c = p.exports;
const m = {
  name: "NcUserBubble",
  components: {
    NcAvatar: a,
    NcPopover: n,
    NcUserBubbleDiv: c
  },
  props: {
    /**
     * Override generated avatar, can be an url or an icon class
     */
    avatarImage: {
      type: String,
      default: void 0
    },
    /**
     * Provide the user id if this is a user
     */
    user: {
      type: String,
      default: void 0
    },
    /**
     * Displayed label
     */
    displayName: {
      type: String,
      default: void 0
    },
    /**
     * Whether or not to display the user-status
     */
    showUserStatus: {
      type: Boolean,
      default: !1
    },
    /**
     * Define the whole bubble as a link
     */
    url: {
      type: String,
      default: void 0,
      validator: (t) => {
        var e;
        try {
          return t = new URL(t, (e = t == null ? void 0 : t.startsWith) != null && e.call(t, "/") ? window.location.href : void 0), !0;
        } catch {
          return !1;
        }
      }
    },
    /**
     * Default popover state. Requires the UserBubble
     * to have some content to render inside the popover
     */
    open: {
      type: Boolean,
      default: !1
    },
    /**
     * Use the primary colour
     */
    primary: {
      type: Boolean,
      default: !1
    },
    /**
     * This is the height of the component
     */
    size: {
      type: Number,
      default: 20
    },
    /**
     * This is the margin of the avatar (size - margin = avatar size)
     */
    margin: {
      type: Number,
      default: 2
    }
  },
  emits: [
    "click",
    "update:open"
  ],
  computed: {
    /**
     * If userbubble is empty, let's NOT
     * use the Popover component
     * We need a component instead of a simple div here,
     * because otherwise the trigger template will not be shown.
     *
     * @return {string} 'Popover' or 'UserBubbleDiv'
     */
    isPopoverComponent() {
      return this.popoverEmpty ? "NcUserBubbleDiv" : "NcPopover";
    },
    /**
     * Is the provided avatar url valid or not
     *
     * @return {boolean}
     */
    isAvatarUrl() {
      if (!this.avatarImage)
        return !1;
      try {
        return !!new URL(this.avatarImage);
      } catch {
        return !1;
      }
    },
    /**
     * Do we have a custom avatar or not
     *
     * @return {boolean}
     */
    isCustomAvatar() {
      return !!this.avatarImage;
    },
    hasUrl() {
      return this.url && this.url.trim() !== "";
    },
    isLinkComponent() {
      return this.hasUrl ? "a" : "div";
    },
    popoverEmpty() {
      return !("default" in this.$slots);
    },
    styles() {
      return {
        content: {
          height: this.size + "px",
          lineHeight: this.size + "px",
          borderRadius: this.size / 2 + "px"
        },
        avatar: {
          marginLeft: this.margin + "px"
        }
      };
    }
  },
  mounted() {
    !this.displayName && !this.user && i.util.warn("[NcUserBubble] At least `displayName` or `user` property should be set.");
  },
  methods: {
    onOpenChange(t) {
      this.$emit("update:open", t);
    },
    /**
     * Catch and forward click event to parent
     *
     * @param {Event} event the click event
     */
    onClick(t) {
      this.$emit("click", t);
    }
  }
};
var d = function() {
  var e = this, r = e._self._c;
  return r(e.isPopoverComponent, { tag: "component", staticClass: "user-bubble__wrapper", attrs: { trigger: "hover focus", shown: e.open }, on: { "update:open": e.onOpenChange }, scopedSlots: e._u([{ key: "trigger", fn: function() {
    return [r(e.isLinkComponent, { tag: "component", staticClass: "user-bubble__content", class: { "user-bubble__content--primary": e.primary }, style: e.styles.content, attrs: { href: e.hasUrl ? e.url : null }, on: { click: e.onClick } }, [r("NcAvatar", { staticClass: "user-bubble__avatar", style: e.styles.avatar, attrs: { url: e.isCustomAvatar && e.isAvatarUrl ? e.avatarImage : void 0, "icon-class": e.isCustomAvatar && !e.isAvatarUrl ? e.avatarImage : void 0, user: e.user, "display-name": e.displayName, size: e.size - e.margin * 2, "disable-tooltip": !0, "disable-menu": !0, "show-user-status": e.showUserStatus } }), r("span", { staticClass: "user-bubble__name" }, [e._v(" " + e._s(e.displayName || e.user) + " ")]), e.$slots.name ? r("span", { staticClass: "user-bubble__secondary" }, [e._t("name")], 2) : e._e()], 1)];
  }, proxy: !0 }], null, !0) }, [e._t("default")], 2);
}, _ = [], f = /* @__PURE__ */ s(
  m,
  d,
  _,
  !1,
  null,
  "55ab76f1",
  null,
  null
);
const N = f.exports;
export {
  N as default
};
